export const BillToTitle = "BILL TO";
export const ShipToTitle = "SHIP TO";
export const SubtotalText = "Subtotal";
export const OtherChargesAndDiscountsText = "Added Order Charges/Discounts";
export const OtherChargesAndDiscountsListAckText = "Added Order Discounts";
export const BillToIsInactiveText =
	"The Bill To Number selected on the original order has been deactivated. Please select a new Bill To Number.";
export const NoActiveBillTosText = "Active Bill To unavailable. Please contact your Account Manager for support.";
export const NetTotalText = "Net Total";
export const FreightCharge = "Freight Charge";
export const TariffSurchargeText = "Tariff Surcharge";

export const EstimatedTaxText = "Estimated Tax";

export const NoDesignerText = "Designer not identified";

export const AccountNumberText = "Account #";
export const OriginalOrderText = "Original Order";

export const myOrdersLinkText = "My Orders";
export const ViewAssociatedOrdersText = "View Associated Orders";
export const ReturnAuthorizationFormText = "Return Authorization Form";

export const searchHeaderButtonText = "Search";
export const InactiveAccounts = "Inactive Accounts";

export const searchBarHelperText = "Search by Account #, Order #, PO #, Confirmation #, Truck #, or Job Name";
export const searchOrdersText = "Search Orders";
export const minCharCountText = "Please enter at least 3 characters.";
export const myOrdersText = "My Orders";
export const NoOrdersFoundHeader = "We're sorry, we couldn't find any orders!";

export const NoOrderDetailsFoundHeader = "Uh oh, order not found!";

export const NoChargeOrder = "NO CHARGE ORDER";

export const NoOrderDetailsFoundSubheader =
	"The order you requested could not be located in our system. Please contact Care if additional help is needed.";

export const NoOrdersFoundFirstBullet = "Placing an order";
export const NoOrdersFoundSecondBullet = "Adjusting your filters";

export const ReturnToSignInButtonText = "Return to Sign In";

export const ReturnToMyOrdersButtonText = "Return to My Orders";

export const ReturnToDashboardButtonText = "Return to Dashboard";

export const PendingApprovalHeader = "Your account is pending approval!";

export const PendingApprovalDescription =
	"Your Sales Rep is working on getting your access ready for you. You should be able to log in soon, but if you need access more quickly, please reach out to them directly. ";

export const ApprovedAccountHeader = "We're sorry, there is a problem with your account access";

export const ApprovedAccountDescription =
	"Looks like we need to check your account access before processing your request. Please contact your Sales Rep to remedy your access.";

export const AccessDeniedHeader = "Not sure what is happening! It appears your access is denied.";

export const AccessDeniedDescription = "If you already have an account, please contact your Sales Rep for access.";

export const OrderSummary400ErrorHeader = "We're sorry, something went wrong with your search.";

export const OrderSummary403ErrorHeader = "Whoops!";

export const OrderSummaryDefaultErrorHeader = "Uh oh, something went wrong!";

export const ServiceUnavailableHeader = "Uh oh, something went wrong!";

export const OrderSummary400ErrorText = "Please try again shortly or contact your Sales Rep should the issue continue.";

export const OrderSummary403ErrorText =
	"Seems as if you need permission to see what you are requesting. Please contact your Sales Rep to remedy your access.";

export const OrderSummaryDefaultErrorText =
	"This is embarrassing! The server is temporarily unable to process your request. Please try again shortly by refreshing your page or contact your Sales Rep should the issue continue.";

export const ServiceUnavailableText =
	"This is embarrassing! The server is temporarily unable to process your request. Please try again shortly by refreshing your page or contact your Sales Rep should the issue continue.";

export const NotFoundHeader = "Uh oh, page not found!";

export const NotFoundText =
	"The page you are looking for appears to have been moved, deleted, or doesn’t exist. Try accessing what you need again or contact your Sales Rep if additional help is needed.";
export const UnavailableDataPlaceholderText = "--";
export const OrderDateRangeLabel = "Select Order Date Range";
export const OrderDateText = "Order Date";
export const OrderNumberText = "Order #";
export const ConfirmationNumberText = "Confirmation #";
export const AddressLine1Text = "Address Line 1";
export const DoorStyleText = "Door Style";
export const FinishText = "Finish";
export const RequestedDateText = "Requested Date";
export const CabinetCountText = "Cab #";
export const AccessoryCountText = "Acc #";
export const CubeCountText = "Cube #";
export const AckCabinetCountText = "Cabinets";
export const AckAccessoryCountText = "Accessories";
export const AckCubeCountText = "Cubes";
export const QuantityText = "Qty";
export const QuantityFullText = "Quantity";
export const ExtendedListPrice = "Ext. List Price";
export const ExtendedUnitPrice = "Ext. Net Price";
export const StandardListPriceText = "Std. List Price";
export const StandardUnitPriceText = "Std. Unit Price";
export const AdjustedListPriceText = "Adj. List Price";
export const AdjustedListTotalText = "Adjusted List Total";
export const AdjustedNetPriceText = "Adj. Unit Price";
export const PromotionText = "Promotion";
export const FinalPriceText = "Final Price";
export const EditedText = "Edited";
export const OnBackorderText = "On Backorder";
export const ItemOnBackorderText = "This item is affected by a backorder";
export const ShipmentText = "Shipment ";
export const OnBackorderAccordionText =
	"Items in this order have been placed on backorder and may arrive separately from the original order placed. Backorder item(s) are placed on priority production and will be shipped to you as soon as possible.";
export const TrackingNumberText = "Tracking #";
export const TruckNumberText = "Truck #";
export const PartOnBackorderText = "Part on Backorder";
export const ItemAffectedText = "Item Affected";
export const ETAText = "ETA:";
export const ETATextOnly = "ETA";
export const CarrierText = "Carrier";
export const LineItemsInOrderText = "Line Items";

export const OrderDetailFlyoutHeader = "Item Details";
export const LegalNoticeText = "Legal Notice:";

export const OrderDetailFlyoutAlertHeaderParts = "Items on Backorder";

export const OrderDetailFlyoutAlertHeaderCabinet = "Whole Cabinet on Backorder";

export const OrderDetailFlyoutBackorderPartsAlertText =
	"Items of your order are on backorder and have been placed on priority production. They may ship separately from the rest of your order.";

export const OrderDetailFlyoutBackorderCabinetAlertTextPartOne = "This cabinet";

export const OrderDetailFlyoutBackorderCabinetAlertTextPartTwo =
	"is on backorder and may ship separately from the rest of your order.";

export const OrderDetailFlyoutQualityBackorderedLabel = "Quantity backordered";

export const OrderDetailFlyoutArrivalDateLabel = "Arrival date";

export const FlyoutItemNumberLabel = "Item Number";

export const FlyoutDoorStyleLabel = "Door Style";

export const FlyoutConstructionLabel = "Construction";

export const HingeText = "Hinge";

export const OrderDetailFlyoutQuantityLabel = "Quantity";

export const OrderDetailFlyoutModificationsDetailsLabel = "Details";

export const OrderDetailFlyoutModificationsValueLabel = "Value";

export const OrderDetailFlyoutModificationsPriceLabel = "Price";

export const ListPriceText = "List Price";

export const OrderDetailFlyoutExtendedPriceLabel = "Extended Price";

export const FlyoutModificationsLabel = "Modifications";

export const FlyoutFinishNameLabel = "Finish Name";

export const FlyoutStandardDimensionsLabel = "Standard Dimensions";

export const OrderDetailFlyoutDepthLabel = "Depth";

export const OrderDetailFlyoutWidthLabel = "Width";

export const OrderDetailFlyoutHeightLabel = "Height";
export const ItemText = "Item";
export const ItemsText = "Items";
export const TotalItemsText = "Total Items";
export const SingleCardTruckText = "Truck";

export const SingleCardTrackingText = "Tracking";

export const WithinLastThreeMonthsLabelText = "Last 3 months";
export const WithinLastSixMonthsLabelText = "Last 6 months";
export const WithinLastTwelveMonthsLabelText = "Last 12 months";
export const CustomDateText = "Custom Date Range";
export const SearchButtonText = "Search";
export const OrderReplacementsText = "Order Replacements";

export const OrderReplacementsJobName = "Job Name";

export const OrderReplacementsPONumber = "PO #";

export const ReturnToOriginalOrderText = "Return to Original Order";

export const ReplacementsFlyoutSelectPartText = "Select Parts";

export const ReplacementsFlyoutOriginalItemText = "Original Item";

export const ReplacementsSelectAPartError = "Please make a selection to add to your order.";

export const PartsAvailableForReplacementText = "Parts Available for Replacement";

export const ReplacementsAddToOrderButtonText = "ADD TO ORDER";
export const ReplacementsCancelButtonText = "CANCEL";
export const SaveButtonText = "SAVE";
export const SaveDraftButtonText = "SAVE DRAFT";
export const CancelButtonText = "CANCEL";

export const NoReplacementPartsText =
	"There are no replacement parts for this item. Please order the original item for replacement.";

export const OrderLimitMessage =
	"You are seeing the top 1,000 orders in your search range. If you don’t see the order you are are looking for, try adjusting your search or date range.";
export const OrderLimitMessageBottom = "If you do not see your order,  try adjusting your search or date range above.";
export const EmptyFlyoutHeaderText = "Your Order Is Empty";
export const NoLinkedOrdersHeaderText = "No Orders Found!";
export const LinkedOrdersErrorHeaderText = "Uh oh, we're having trouble loading your orders.";
export const EmptyFlyoutHelperText = "Looks like you haven't added anything to your order!";
export const EmptyLinkedOrdersHelperText =
	"Looks like this order does not have any orders associated with it at this time. If you place an Add-on or Replacement order, they will appear in this list.";
export const ErrorLinkedOrdersHelperText =
	"The server is temporarily unable to retrieve your associated orders. Please try searching for your orders in 'My Orders' or check back later.";
export const ShoppingCartContinueButtonText = "Continue Selecting Parts";
export const ShoppingCartProceedButtonText = "Proceed With Order";
export const YourOrderText = "Your Order";
export const AssociatedOrdersHeaderText = "Associated Orders";
export const RemoveText = "Remove";
export const OpenText = "Open";
export const RemoveOrderText = "YES, REMOVE ORDER";
export const AreYouSureRemoveOrderText = "Are you sure you'd like to remove this order?";
export const AreYouSureSubtitleRemoveOrderText =
	"This order will be removed from your truck. It will still be available under the list of order drafts to assign to a truck later.";
export const PartsAddedText = "Part(s) Added";
export const OrderTypeText = "Order Type";
export const JobNameText = "Job Name";
export const OrderNameText = "Order Name";
export const JobNameOptionalText = "Job Name (optional)";
export const PONumberText = "PO #";
export const PONumberRequiredText = "Please enter a PO #.";
export const DesignerNumberText = "Designer #";
export const CommentText = "Comment";

export const OrderReplacementText = "Order Replacement";
export const ItemsAddedText = "Items Added to your Cart";
export const ItemAddedText = "Item Added to your Cart";
export const ReplacementReasonText = "Reason for Replacement";
export const PleaseDescribeTheProblemReplacementText =
	"Please describe what problems you are experiencing with your order";
export const NoChargeOrderText = "NO CHARGE ORDER";

export const RequiredFieldsText = "Required Field (*)";
export const ShippingMethodText = "Shipping Method";
export const AddressText = "Address";
export const EstimatedDeliveryText = "Estimated Delivery";

// --------- Replacements Review -----------
export const ReplacementReviewText = "Review and Order Replacement";
export const ReplacementReviewStepperText = "Review and Place Order";

export const SelectReplacementReasonText = "Select Reason for Replacement";
export const DescribeYourProblemText = "Describe the Problem";

export const PleaseSelectReplacementReasonErrorText = "Please select the reason for replacement";
export const PleaseDescribeYourProblemErrorText = "Please describe your problem";
export const ReasonDamage = "Damage";
export const ReasonFinishOrSurfaceDefects = "Finish or Surface Defects";
export const ReasonWrongOrMissingProduct = "Incorrect Item or Missing Product";
export const UnauthorizedErrorHeader = "Uh oh, is that you?";
export const UnauthorizedErrorDescription = "Let's just verify it's you by signing in again.";
export const UnauthorizedErrorDisclaimer = "If you continue to run into problems, please contact your Sales Rep.";

export const UnauthorizedErrorCode = "(Error Code: 401)";

export const AuthErrorErrorCode = "(Error Code: 500)";
export const MaxQuantitySelectedText =
	"You have selected the maximum number of parts available to be replaced for this item. A replacement of the original item cannot be requested.";
export const MaxQuantityPartsSelectedText =
	"You have selected to replace all of the original items ordered. A replacement of additional parts cannot be requested.";

export const ReplacementReason = "Replacement Reason";
export const EditText = "Edit";
export const ReplaceOriginalItem = "Replace Original Item";

export const OrderListErrorsWarningMessage = "You have orders in statuses that may require attention";

export const SelectThreeImagesText =
	"For the quickest resolution, we encourage you to provide up to 3 images of the damage to help our quality team prevent future issues.";
export const SupportedFilesHeader = "Supported Files:";
export const DefaultSupportedFiles = "JPG, JPEG, PNG, PDF";
export const AttachingText = "ATTACHING";
export const AttachFile = "Attach File";
export const SendCommentText = "Send Comment";
export const AttachedFiles = "Attached Files";
export const MaxFileSizeHeader = "Max File Size:";
export const MaxFileSize = "10MB";
export const MaxUploadsError = "Max limit of 3 image files exceeded. Please select no more than 3 files to upload.";

export const UnableToDetermineFiles = "Unable to determine file(s). Please try uploading again.";
export const LowesFileUploadRequiredError = "Please add an attachment file before continuing.";

export const DragFile = "Drag your file(s) here or";
export const BrowseFiles = "Browse Files";
export const PerImage = "per image";

export const OrderDetailsText = "Order Details";
export const AcknowledgementText = "Acknowledgement";

export const ReplacementReviewShippingHeader = "Ship To";

export const ReplacementReviewShippingMethodHeader = "Shipping Method";

export const ReplacementReviewShippingToHeader = "Ship To";

export const ReplacementReviewReplacementReasonText = "Replacement Reason";

export const ReplacementReviewUploadedImagesText = "Uploaded Images";

export const ReplacementReviewSubmitOrder = "Submit Order";

export const ReplacementReviewShippingLabelNotes = "Shipping Label Notes";

// File Validation
export const FileSuccessText = "Success!";
export const FileTooLargeText = "File too large! The maximum upload file size is 10MB. Please try again.";
export const FileTooSmallText = "File too small! The minimum upload file size is 1KB. Please try again.";
export const FileIncorrectTypeText = "Unsupported file! Image must be JPG, JPEG, PNG, or PDF. Please try again.";
export const FileDuplicateText = "A file with this name has already been attached. Please try again.";
export const ProperlyExportText = "View how to properly export a CSV file ";

export const BackText = "Back";
export const ContinueText = "Continue";

export const ReplacementConfirmationHeader = "Thank you!";

export const ReplacementConfirmationSubheader =
	"Your order has been submitted. We will get started on your order right away and you will see updates in Tandem soon. If further information is required to process your request we will reach out to you directly.";

export const ReplacementConfirmationLabel = "Replacement Order";
export const ReplacmentConfirmationOrderNumber = "Order #";
export const ReplacementConfirmationOriginalOrderNumber = "Original Order #";

export const ReplacmentConfirmationOrderPending = "Pending";
export const ReplacementShipToAddressSubheaderText = "Address";
export const ReplacementShipToDeliveryContactSubheaderText = "Delivery Contact";
export const ReplacementShipToShippingMethodText = "Shipping Method";
export const ReplacementShipToOrderContactText = "Order Contact";
export const ShipToFormUsingInfoText = "We'll use this information to contact you about your order.";
export const ReplacementsShipToFormShippingLabelNotes = "Shipping Label Notes";
export const ReplacementsShipToFormShippingLabelSubheader =
	"This information will be printed on your shipping label for your reference only";

// Exit Replacements Warning
export const AreYouSureText = "Are you sure you'd like to leave this order?";
export const SaveDraftBeforeLeavingText = "Would you like to save this draft before leaving?";
export const ItemsWillClearText = "The items in your order will not be saved if you leave this screen.";
export const YesExitOrder = "YES, EXIT ORDER";
export const NoContinueOrdering = "NO, CONTINUE ORDERING";
export const BillToText = "Bill To";

export const ReplacementReviewAddress = "Address";

export const ReplacementReviewNoShipAddress = "Please provide a shipping address to proceed with your order.";

export const ReplacementReviewDeliveryContact = "Delivery Contact";

// Replacement Order Submitted Banner on OrderDetailsHeader
export const ReplacementOrderSubmitted = "Replacement Order Submitted";
export const ReplacementOrderSubmittedText =
	"Updates will typically be available in Tandem within 10 minutes. If any further information is needed to process your order, we will reach out directly.";

export const ReplacementPost400ErrorHeader = "We're sorry, we couldn't process your order.";

export const ReplacementPost400ErrorHeader4000Errors =
	"We're sorry, we couldn't process your order. Please check that the following information is correct:";

export const ReplacementPost400ErrorDescription =
	"Something doesn't look correct. To proceed with your order please check that your order details and shipping information are correct before submitting again.";

export const NewOrderLineItemImportErrorSubheader =
	"Please correct all of the following line item errors before proceeding with your order. If you have corrected all of the errors and the problem continues, please contact Care.";
export const NewOrderCouldNotGeneratePriceEstimateHeader = "We're sorry, we couldn’t generate your price estimate.";
export const NewOrderEstimateErrorSubHeader =
	"Something doesn't look correct. Please try the following to proceed with your order:";
export const NewOrderEstimateErrorGenerateAgainBullet = "Generate the price estimate again";
export const NewOrderEstimateErrorUpdateLineItemsBullet = "Review and update line item(s) that have errors";
export const NewOrderEstimateErrorReviewGuidelinesBullet =
	"Review product guidelines in the Product Spec Book (make sure you are reviewing the latest version)";
export const NewOrderEstimateErrorReUploadBullet = "Review and re-upload your CSV file";
export const NewOrderPleaseContactCare =
	"If you have tried all of the steps above and the problem continues, please contact Care.";
export const NewOrderPleaseSubmitRequestText =
	"If you have tried all of the steps above and the problem continues, please";
export const SubmitTandemRequestText = "submit a Tandem Support Request";
export const NewOrderEstimateErrorSaveAsADraftBullet = "Save your order as a draft and try again later";
export const NewOrderContactAccountManagerSubheader =
	"Something doesn't look right. Please contact your Account Manager to proceed with your order";
export const SelectAccountAndBillTo = "Ensure all Account #s and Bill To #s are selected";
export const SomethingDontLookRightText =
	"Something doesn't look correct. Before submitting again, please try the following to proceed with your order:";

export const OrderNotFoundHeader = "Uh oh, we're having trouble retrieving your Original order";
export const DraftOrderNotFoundHeader = "Uh oh, we're having trouble retrieving your Draft order";

export const OrderNotFoundDescription =
	"The server is temporarily unable to process your replacement request. Please try again or contact your Sales Rep if the problem persists.";

export const DraftOrderNotFoundDescription =
	"The server is temporarily unable to locate your draft order. Please try again or contact your Sales Rep if the problem persists.";
export const RequestToRemoveDraft = "Request to Remove Draft";
export const RequestToRemoveTemplate = "Request to Remove Template";

export const ReplacementResubmitHeader = "Hooray! Your order is already being processed.";

export const ReplacementResubmitDescription =
	"Looks like your order has already been submitted and is currently being processed. You will see updates in Tandem within 10 minutes.";

export const AddNewAddressLink = "+ Add New Address";
export const ImageUploadError = "Images Failed to Upload";
export const ImageUploadErrorMessage =
	"The images you attached failed to upload. If they are required to process your order, we will reach out directly.";
export const NewOrderErrorMaintenanceHeader =
	"We're sorry, we are undergoing maintenance and cannot process your request at this time.";
export const NewOrderErrorMaintenanceSubHeader =
	"Please save your order as a draft and try again after the scheduled maintenance is over.";
export const GenericOrderErrorMaintenanceSubHeader = "Please try again after the scheduled maintenance is over.";

// Form Error Text
export const PhoneNumberFormError = "Please enter a valid Phone Number.";

export const RequestDeliveryDateFormError =
	"Please select a valid request date between 5-90 business days from today's date.";
export const RequestDateErrorHelperDescription = "The order Request Date you previously selected is no longer valid.";
export const RequestTruckDateFormError = "Please select a request date between 10-90 business days from today's date.";
export const EmailFormError = "Please enter a valid email address.";
export const CharacterLimitExceeded = "Limit Exceeded.";
export const ReplacementShipToFormDeliveryText = "Delivery";
export const ReplacementShipToFormPickupText = "Pickup";

export const PhoneLabelOptional = "Phone (optional)";
export const PhoneLabel = "Phone";
export const EmailLabel = "Email (optional)";
export const RequiredFieldNotice = "Required Field (*)";

// Add New Address Form
export const AddNewAddressTitle = "Add New Address";
export const VerifyLoadingMessage = "Hang tight while we add your new address...";
export const VerifyAddressConfirmYourAddress = "Confirm Your Address";
export const VerifyAddressWeSuggest = "We Suggest";
export const VerifyAddressYouEntered = "Address You Entered";
export const VerifyAddressErrorMessage =
	"We were not able to verify the address you entered. Please edit or confirm your address. Orders with incorrect addresses may be delayed or lost.";
export const FullNameLabel = "Full Name";
export const FullNameHelperText = "This can be the name of your business or contact.";
export const AddressHelperText = "Orders cannot be shipped to a PO Box.";
export const AddressLabel = "Address";
export const Address2Label = "Apt, Suite, etc. (optional)";
export const CityLabel = "City";
export const StateLabel = "State";
export const ZipLabel = "ZIP";
export const CountyLabel = "County";
export const SaveAndContinueButton = "Save and Continue";
export const EditAddressButton = "Edit Address";

export const ListboxKeepTyping = "Keep typing address to display results";
export const ContactInformationTitle = "Contact Information";
export const ContactInformationNotice = "This will be the contact information associated with your new address.";
export const ModalCancel = "Cancel";
export const ModalSave = "Save";

export const FullNameFormError = "Please enter a Full Name.";
export const AddressFormRequiredError = "Please enter a Street Address.";
export const AddressFormError = "Please enter a Street Address. Orders cannot be shipped to a PO Box.";
export const Address2FormError = "Orders cannot be shipped to a PO Box.";
export const CityFormError = "Please enter a City.";
export const StateFormError = "Please select a State";
export const ZipFormError = "Please enter a ZIP.";
export const CountyFormError = "Please enter a County.";

export const FieldError = "Form Field Error";

// Export PDF and CSV Text
export const exportPDFText = "Export as PDF";
export const exportPDFExpandedText = "Export PDF - Expanded";
export const exportPDFCondensedText = "Export PDF - Condensed";
export const exportCSVText = "Export to Excel";
export const exportOrdersText = "EXPORT ORDERS";
export const OrdersText = "ORDERS";
export const OrderText = "ORDER";
export const exportOrderDetailsText = "EXPORT ORDER DETAILS";
export const exportAcknowledgementText = "EXPORT ACKNOWLEDGEMENT";
export const ExportTrucksText = "EXPORT TRUCKS";
export const ExportDetails = "EXPORT DETAILS";
export const LargeModalPDFText = {
	PDFTooLarge:
		"The following orders exceed the maximum export limit of 800 orders for PDFs. If you would like to export your orders as a PDF, please narrow your results.",
	ProceedWithExcelPrompt:
		"There is no limit on exporting an excel file. Would you like to proceed with an excel export?",
	CloseButtonLabel: "Close and try again",
	LargeFileTitle: "Large File",
	ExportExcelOption: "Export to Excel"
};
export const NoAccountText =
	"It looks like your account does not have permission to order this product line. Please contact your Account Manager.";
export const ExportConfirmationText = "EXPORT CONFIRMATION";
export const OrderConfirmationText = "Order Confirmation";
export const GeneratedText = "Generated: ";
export const OrderAddOns = "Order Add-Ons";
export const LowesOrderAddOns = "Lowe's XP Order";
export const CancelOrderText = "Cancel Order";

export const StatusUpdatedText = "Status Updated: ";
export const AddOnText = "AddOn";
export const ProductLines = "Product Line(s)";

// Navigation Constants

// ---------------Custom Quotes---------------
export const CustomQuotesHeaderText = "Custom Quotes";
export const RequestQuoteButtonText = "REQUEST QUOTE";

export const CommentsText = "Comments";
export const NoCommentsYetText = "No comments yet";
export const EmptyCommentsPlaceholderText = "Send a comment to see it here";
export const CommentTextareaPlaceholder = "Write a comment...";
export const CommentsInfoLabel = "Please Note:";
export const CommentsInfoText =
	"Comments that include another quote request will not be processed. Please submit a second quote request if another is needed.";
export const CommentSectionHeaderText = "COMMENTS SENT";
export const AttachedFilesText = "Attached Files";
export const CabinetworksGroupText = "Cabinetworks Group";

export const AttachmentText = "Attachment";

export const CustomQuoteRecivedStatusDescription = "Your request has been submitted to Cabinetworks Group to review.";
export const CustomQuoteUnderReviewStatusDescription = "Request is under review by Cabinetworks Group.";
export const CustomQuoteReadyToOrderStatusDescription = "Custom Quotes available to review and order.";
export const CustomQuoteDeclinedStatusDescription =
	"Your request has been declined. Please submit a new request if you wish to proceed with a Custom Quote.";
export const CustomQuoteExpiredStatusDescription =
	"This Quote is expired. Please request a revision on this quote in the comments for an updated estimate.";

// Custom Quote Decline Modal
export const DeclineRequestModalTitle = "Would you like to decline this request?";
export const DeclineRequestRequiredFieldText = "Required Field (*)";
export const DeclineReasonSectionTitle = "Decline Reason";
export const DeclineReasonSectionDescription =
	"Select a reason for declining this request. Your selection will only be seen internally by Cabinetworks Group.";
export const DeclineReasonLabel = "Select Reason for Decline *";
export const MessageDesignerSectionTitle = "Message Designer";
export const MessageDesignerSectionDescription =
	"Send a message to the Designer explaining the reason for declining the request along with any additional helpful information regarding the ask.";
export const MessageDesignerPlaceholder =
	"We appreciate you taking the time to complete this form using the most updated, detailed information as possible. This helps us provide faster and more accurate service to you.\n\nEach item requires a separate form to be submitted (one item per request form submission).\n\nAppliance Panel Service: Provide us with the appliance make & model and our custom quote team will do all the research and determine the correct dimensions.\n\nOver Cut-Out Cabinets: Provide with the cut-out dimensions (OCM:__Wx__H) and/or cut-out location. If multiple cut-outs, please specify: Top, Middle, Bottom. *We will not interpret cut-out dimensions from manufacturer spec sheets.*";
export const HelpfulResourcesTitle = "Helpful Resources:";

export const DeclineRequestButtonText = "DECLINE REQUEST";
export const GeneralFAQText = "General & Appliance Panel FAQs";
export const EnterQuote2020Text = "How to Enter a Custom Quote in 2020";
export const FailedToDeclineRequestText = "Failed to decline request. Please try again.";

// ---------------NewOrders---------------
export const ImportFileText = "IMPORT FILE";
export const ManualOrderEntryText = "Manual Order Entry";
export const CreateYourItemSubtitleText = "Create your item list by adding individual items.";
export const TruckOrdersText = "Truck Orders";

export const AddItemText = "ADD ITEM";
export const FindOriginalOrderText = "FIND ORIGINAL ORDER";
export const PlaceANewOrderText = "Place a New Order";
export const NewOrderMarketingMaterialsBannerPrefixText = "To buy sample chips and branded merch, please visit our new";
export const NewOrderMarketingMaterialsBannerLinkText = "Marketing Materials page";
export const MarketingMaterialsNewOrderBannerPrefixText = "For cabinet orders, please go to";

export const StartANewQuoteText = "Start a New Quote";
export const StartOver = "Start Over";
export const CustomQuoteRequest = "Custom Quote Request";
export const AddCustomQuoteText = "Add Custom Quote";

export const NoExitOrder = "NO, EXIT ORDER";
export const YesSaveDraft = "YES, SAVE DRAFT";
export const DraftANewOrderText = "Draft New Order";
export const ImportCSVText = "Import CSV";
export const CreateYourItemText = "Create your item list using 2020, ProKitchen, etc.";
export const SupportedFilesText = "Supported Files: ";
export const CSVText = "CSV";
export const DownloadLatestText = "Download the latest catalogs";
export const HereText = "here.";
export const ReplacementOrAddOnText = "Order Replacements or Add-ons";
export const FindOriginalText = "Find the original order to purchase an add-on or request a replacement.";
export const SelectAccountText = "Select Account #";
export const SelectBillToText = "Select Bill To #";
export const AllFieldsRequiredText = "All fields required.";
export const FileNameText = "File Name";
export const CatalogText = "Catalog";
export const StartOverText = "START OVER";
export const ContinueButtonText = "CONTINUE";
export const ImportAddOnErrorText =
	"An Add-On order can only include Product Lines that are associated with the same Account # and Bill To as the Original order. Please try again with a Product Line that is compatible.";
export const SelectAccountAndBillingText = "Select Account and Billing Information";
export const SearchItemText = "Search by item # or item description";
export const SearchPartText = "Search by part # or part description";
// Welcome message for care user
export const defaultMessageForCareUserText = "Welcome, start searching to see your orders!";
export const ToAccessText = "To place a custom color order, ";
export const ClickHere = "click here.";
export const HangTightTitle = "Hang tight while we process your order!";
export const HangTightSubtitle =
	"Your order has been received and we are working on processing your request. Updates will typically be available in Tandem within 10 minutes. Your line items will be available to view soon.";
export const NoLineItemsAvailableText = "No line items available";

export const AddressRequiredText = "Please select an Address.";

export const EstimatedDeliveryToolTipDesc = "Estimated arrival at the shipping address";

export const PAGE_ERROR = "There was an Error, please try again.";
export const AUTH_ERROR = "There was an Authentication Error, please log in again.";

export const DeliveryText = "Delivery";
export const PickupText = "Pickup";

export const LoadingLabel = "Loading";

// ---------------AddOns---------------
export const BuildYourOrderText = "How would you like to build your order?";
export const OriginalOrderDetailsText = "ORIGINAL ORDER DETAILS";
export const ProductLineText = "Product Line";

// --------------- User Emulation ---------------
export const UserEmulationModalTitle = "Emulate by Account Number or User Email";
export const UserEmulationEmailLabel = "Select User Email";
export const UserEmulationAccountLabel = "Enter Account";
export const UserEmulationSwitchLabel = "Emulation";
export const UserEmulationConfirmButton = "Emulate";
export const UserEmulationBackButton = "Back to Care Mode";
export const UserEmulationFormEmailErrorText = "Please select a User Email";
export const UserEmulationFormAccountErrorText = "Please select a User Account";
export const UserEmulationNowViewing = "Now Viewing";
export const UserEmulationChange = "Change";
export const UserEmulationOrDividerText = "or";

// Create Truck
export const SelectAccountNumberText = "Please Select an Account #.";
export const SelectProductLineText = "Please Select a Product Line.";
export const EnterTruckNameText = "Please enter a Truck Name.";
export const InvalidTruckNameText = "Draft name must contain characters. Please enter a valid draft name.";
export const CantProcessRequestText = "We're sorry, we couldn't process your request.";
export const SomethingDoesntLookRightText =
	"Something doesn't look correct. Before submitting again, please check the following to proceed with your order:";
export const ShippingAddressText = "Shipping Address";
export const UniqueTruckErrorText = "This Truck Name has already been used. Please enter a unique Truck Name.";
export const SaveAndAddOrdersText = "Save and Add Orders";
export const AddStopText = "ADD STOP";
export const ShippingInfoText = "Shipping Information";
export const TruckInfoText = "Truck Information";
export const SelectShippingAddressText = "Select Shipping Address";
export const SelectRequestDateText = "Please select a Request Date.";
export const SelectShippingAddressErrorText = "Please select a Shipping Address.";
export const SaveTruckText = "Save Truck";
export const UpdateTruckStopText = "Update Truck Stop";
export const RemoveStopText = "REMOVE STOP";
export const AreYouSureRemoveStopText = "Are you sure you'd like to remove this stop?";
export const AreYouSureRemoveStopDetailText =
	"This stop and all of the orders assigned to the stop will be removed from the truck.";
export const ConfirmRemoveStopText = "Yes, remove stop";
export const AddOrderText = "ADD ORDER";
export const YouDoNotHaveAnyOrdersText = "You do not have any orders assigned to this stop";
export const AddOrdersToViewText = "Add orders to this stop to view them here";
export const AddTruckStopText = "Add Truck Stop";
export const StopNumberText = "Stop #";
export const AddOrderToTruckText = "Add Order to Truck";
export const SelectOrderText = "Please select an Order";
export const AddToTruckText = "Add to Truck";
export const SelectOrderDraftText = "Select Order Draft";
export const AddOrderToTruckErrorText = "Please add at least one order to your truck.";
export const AddStopToTruckErrorText = "Please add at least one stop to your truck.";
export const ServerTemporarilyUnavailableText =
	"The server is temporarily unable to process your request at this time. Please try again later or contact Customer Care if the issue continues.";
export const SearchTruckOrdersText = "Search Orders by Job Name or PO #";

export const CreatedDateText = "Created Date";
export const ViewDraftText = "View Draft";
export const CantFindOrderInTruckText = "We're sorry, we couldn't find your order!";
export const AddOrderDraftsToTruckText = "Add order drafts to this truck";

// Trucks Landing Page
export const TruckNameText = "Truck Name";
export const CubesAvailableText = "Cubes Available";
export const RequestDateText = "Request Date";
export const OpenTrucksText = "Open Trucks";
export const ProcessedTrucksText = "Processed Trucks";
export const CreateTruckText = "Create Truck";

// Custom Color
export const OrderCustomColorSample = "Order Custom Color Sample";
export const CustomColorText = "Custom Color";
export const PaintVendorText = "Paint Vendor";
export const EnterVendorText = "Enter Vendor";
export const EnterColorCode = "Enter Color Code";
export const ColorOptionText = "Color Option";
export const AddAnotherColorText = "Add Another Color";
export const VendorText = "Vendor";
export const AddColorText = "ADD COLOR";
export const CustomText = "CUSTOM";
export const MissingCustomColorAlertBannerTitle = "Missing Custom Color Orders";
export const MissingCustomColorAlertBannerMessage =
	"Your CSV file includes a custom color option that is currently not associated with your account. Please check the status of your custom color orders or submit a new custom color sample order to proceed.";
export const CSVIncludesCustomColorMessage =
	"Your CSV file includes a custom color. Please select a custom color below.";
export const SelectCustomColorTitle = "Select Custom Color";
export const OrderSampleButtonText = "ORDER SAMPLE";

// Trucks Header
export const CreateANewTruckText = "Create a New Truck";
export const NoContinueText = "Continue with Truck";
export const ExitTruckText = "Exit Truck";
export const AreYouSureTruckText = "Are you sure you'd like to leave your truck?";
export const InformationWillBeWipedText =
	"The information you entered here will not be saved if you leave this screen.";

// Trucks Steps
export const EnterTruckInformationText = "Enter Truck Information";
export const AddOrdersText = "Add Orders";
export const ReviewTrucksText = "Review and Submit Truck Orders";

// Trucks Processed Trucks
export const InProductionTooltipText = "Truck has been submitted to Cabinetworks Group and orders are being processed.";
export const CompleteTooltipText = "Truck is en route to shipping address.";
export const NoTrucksTitleText = "We’re sorry, we couldn’t find any processed trucks!";
export const NoTrucksListText = "To see trucks on this list, please try:";
export const NoTrucksFirstBulletText = "Adjusting your filters";
export const NoTrucksThirdBulletText = "Submitting a truck order";
export const TrucksStatusDefaultLabel = "Truck Status";
export const SearchTrucksPlaceholderText = "Search Trucks by Name or Truck #";
export const CompleteTrucksStatusLabel = "Complete";
export const InProductionTrucksStatusLabel = "In Production";
export const OpenTrucksStatusLabel = "Open";

// Trucks Details Flyout
export const TruckDetailsFlyoutTitle = "Orders on Truck";
export const TruckDetailsFlyoutEstimatedDeliveryTooltip = "Estimated arrival of order in full at the shipping address.";
export const TruckDetailsFlyoutRequestedDeliveryLabel = "Requested Delivery Date";
export const TruckDetailsFlyoutPendingStatusTitle = "Order Updates Pending!";
export const TruckDetailsFlyoutPendingStatusSubtitle =
	"Your truck order has been submitted. Your order updates will be available soon.";
export const EditTruckDetailsText = "Edit Truck Details";
// Trucks Review  Truck
export const ReviewTruckStopOrderText = "Order List";
export const ReviewTruckDetailsNote =
	"Note: All orders added to this truck will be given the same request date listed above. ";
export const SubmitTruckOrderButtonText = "SUBMIT TRUCK ORDERS";
export const EstimatedSubTotalText = "Estimated Subtotal";
export const TruckCubeCountErrorText =
	"Make adjustments to or remove orders on this truck to stay within the limits of the truck’s capacity.";
export const TruckErrorBannerSubheader =
	"Something doesn’t look correct. Before continuing, please try the following to proceed with your truck:";
export const TruckErrorBannerProvidePOBullet = "Provide a PO # for all orders in your truck by editing your draft.";
export const TruckErrorBannerChangePOBullet = "Change your PO # to be unique; your PO # has been used before.";
export const TruckErrorBannerAddLineItemsBullet = "Add line item(s) to your order.";
export const TruckErrorBannerRefreshBullet =
	"If you made changes to your drafts, refresh this page to see those changes reflected here.";
export const TruckOrderErrorNeedPO = "Please provide a PO # for all orders before proceeding with your truck.";
export const TruckOrderErrorDuplicatePO = "Please provide a unique PO #; your PO # has been used before.";
export const TruckOrderLineItemsError = "Please add line item(s) to your order.";

// REMOVE TRUCK MODAL
export const RemoveTruckConfirm = "YES, REMOVE TRUCK";
export const RemoveTruckModalTitle = "Are you sure you'd like to remove this truck?";
export const RemoveTruckModalSubtitle =
	"The truck will be removed from your Open Trucks list and cannot be undone. Orders assigned to your  truck will still be available under the list of order drafts to assign to a truck later.";
export const RequestToRemoveTruckText = "Request to Remove Truck";

// TRUCK CONFIRMATION PAGE
export const ThankYouTruckSubmittedSubheader =
	"Your truck order has been submitted. Updates will typically be available in Tandem within 10 minutes. If any further information is needed to process your order, we will reach out directly.";
export const ReturnToTruckOrdersButtonText = "Return to Truck Orders";
export const TruckNumberPending = "Truck # Pending";

// Snackbar
export const TruckSnackbarLoadingText = "Saving Truck";
export const TruckSnackbarSuccessText = "Truck Saved";
export const GeneratingPDFText = "Generating PDF";
export const PDFDownloadText = "PDF exported";
export const PDFErrorText = "PDF export failed. Please try again.";
export const SavingTruckErrorText = "An error occurred while saving the truck. Please try again.";
export const GeneratingDWGText = "Generating AutoCAD File";
export const DWGDownloadText = "AutoCAD File exported";
export const DWGErrorText = "AutoCAD File export failed. Please try again.";

export const PleaseContactSalesRepText =
	"Please contact your Sales Rep if the problem persists and you are certain of your search criteria.";
export const ToSeeOrderOnListText = "To see orders on this list, please try:";
export const CheckYourSearchSpellingText = "Checking your search spelling";

// Paint Chip Instructions
export const PaintChipInstructionsTitleText = "A paint chip is required for this custom color.";
export const PaintChipInstructionsSubtitleText = "Mailing Instructions";
export const PaintChipInstructionsListFirstItemText = "Print this confirmation page";
export const PaintChipInstructionsListSecondItemText =
	"Place the printed confirmation page and your paint chip in an envelope";
export const PaintChipInstructionsListThirdItemText =
	"Mail the envelope to: Attn Customer Care, 10501 10th St, Waconia, MN 55387";
export const PaintChipInstructionsListFourthItemText =
	"Expect your order to be shipped 10 days after we receive the paint chip.";

// Pricing Definition Modal
export const SeePricingInfoText = "See Pricing Info";
export const PricingDefinitionsText = "Pricing Definitions";
export const PricingDefinitionsSubheaderText =
	"The pricing that you see in Tandem and your Acknowledgement are determined by your account settings. If you wish to see different pricing, please contact your Account Admin.";

export const TruckPendingText = "PENDING";

// View Quote Table
export const LastUpdatedText = "Last Updated";
export const CustomQuoteNumberText = "CQ #";
export const CustomItemNameText = "Custom Item Name";
export const StatusText = "Status";
export const UpdateText = "Update";
export const OpenRequestsText = "Open Requests";
export const ExpiredQuotesText = "Expired Quotes";
export const ExpiredQuotesInfoText =
	"Quotes are active for 1 year. After 1 year the quote expires and must be revised for current pricing before the item can be ordered again.";
export const QuoteTableNoResultsFoundHeader = "We're sorry, we couldn't find any quotes!";
export const QuoteTableNoResultsFoundSubheader = "To see quotes in this list, please try,";
export const QuoteSearchBarText = "Search by Quote # or Name";

// Custom Quote Request Form
export const RequestCustomQuoteHeaderText = "Request a Custom Quote";
export const DescribeCustomizationLabel = "Describe Customization *";

export const EnterDesignerNumberLabel = "Enter Designer # *";
export const CustomItemNameLabel = "Custom Item Name *";
export const SelectDesignerNumberLabel = "Select a Designer #";
export const CustomizationDetailsHeaderText = "Customization Details";
export const ManualPercentAdjustment = "Manual Percent Adjustment";
export const ManualFlatAdjustment = "Manual Flat Adjustment";
export const BaseItemListPriceText = "Base Item List Price";
export const CustomizationChargeText = "Customization Charge";
export const AdditionalModNotesText = "Additional Modification Notes";
export const GenerateBasePriceText = "GENERATE BASE PRICE ESTIMATE";
export const OrderDetailsHeaderText = "Order Details";
export const BaseItemHeaderText = "Starting Item";
export const PhotoOrSketchCustomizationText = "Photo or Sketch of Customization";
export const DesignerNumberSixDigitsStartWithOneText = 'Designer # must be 6 digits and start with "1"';
export const DesignerNotFoundContactSalesRepText =
	"If you don't find the designer number you're looking for, contact your Sales rep.";

export const SubmitCustomQuoteRequestButtonText = "Submit Custom Quote Request";
export const CustomQuoteRequestText = "Custom Quote Request";
export const PleaseAttachImagesText =
	"Please attach up to 3 images that would help us in understanding your customization request.";
export const AreYouSureLeaveAddQuoteText = "Are you sure you’d like to leave this quote?";
export const AreYouSureLeaveCreateQuoteText = "Are you sure you’d like to leave this request?";
export const ExitQuoteText = "EXIT QUOTE";
export const ContinueQuoteText = "CONTINUE WITH QUOTE";
export const ContinueRequestText = "CONTINUE WITH REQUEST";
export const ReviseButtonText = "Revise";

// Additional Validation Error Messages
export const PleaseSelectBillToNumberText = "Please select a Bill To #.";

export const PleaseEnterDesignerNumberText = "Please enter a designer number.";
export const DesignerNumberMustBeSixCharactersText = "Designer number must be 6 characters.";
export const MustStartWithOneAndContainOnlyDigitsText = "Must start with '1' and contain only digits.";
export const PleaseDescribeCustomizationText = "Please describe your customization.";
export const PleaseProvideItemNameText = "Please provide an Item Name.";

// New Requests Table
export const NewRequestsText = "New Requests";
export const CompletedRequestsText = "Completed Requests";
export const QuotedByPillText = "Quoted By";
export const LastQuotedByText = "Last Quoted By";
export const AssignedToText = "Assigned To";
export const RequestSearchInputText = "Search by Quote # or Name";
export const CustomQuoteRequestsNoResultsFoundHeader = "We're sorry, we couldn't find any requests!";
export const CustomQuoteRequestNoResultsFoundSubheader = "To see requests in this list, please try,";
export const CustomQuoteRequestAdjustYourFiltersBullet = "Adjusting your filters";
export const CustomQuoteRequestACheckYourSpellingBullet = "Checking your search spelling";
export const CustomQuoteRequestSubmittingBullet = "Submitting a request for a Custom Quote";

export const ContactCareForSearchHelpText =
	"Please contact Customer Care if the problem persists and you are certain of your search criteria.";
export const UpdateAvailableText = "Update Available";
export const QuoterErrorText = "Please select an assignee.";
export const AssigneeText = "Assign To";

export const OrderDetailsPriceValidationErrorTitle = "Unable to Validate Pricing";
export const OrderDetailsPriceValidationErrorBody =
	"The current pricing may be affected by errors on the order. Please contact Care to resolve these errors for a more accurate price estimate.";

// Custom Quote Confirmation Page
export const CustomQuoteConfirmationSubTitle =
	"Your custom quote has been submitted. Due to the high volume of incoming quotes, please allow up to 72 hours for us to respond. Custom quotes are processed in a first in first out order. You will be notified when our engineering team has reviewed your request and will see a quote available in your list of custom quotes when it is ready. Thank you for your patience.";
export const ReturnToCustomQuoteButtonText = "Return to Custom Quotes";

// Add Custom Quote Page
export const AttachCustomQuoteText = "Attach Custom Quote";
export const CustomQuoteDwgText = "Custom Quote DWG & PDF";
export const CustomQuoteDwgInstructionsText =
	"Attach the custom quote generated by AutoCAD along with the matching PDF.";
export const DwgSupportedFiles = "DWG, PDF";
export const SpecialModificationNotesText = "Additional Modification Notes";
export const DwgPdfBothRequiredErrorText = "Please upload one DWG and one PDF file.";
export const CustomQuoteFileTypeIncorrectErrorText = "Unsupported file! Image must be DWG or PDF. Please try again.";

// Admin Settings Page
export const AccountAdminHeaderText = "Account Admin";
export const AdminSearchText = "ADMIN SEARCH";
export const AdminSearchLabelText = "Search People, Accounts, Bill To’s, etc.";
export const ManagePersonalSettingsText = "Manage Personal Settings";
export const MngPrsnlChangeViewSettingsText = "Change view settings for your people.";
export const ManageAckSettingsText = "Manage Account Acknowledgements";
export const ChangeGlobalAckSettingsText =
	"Change global acknowledgement settings for all orders linked to your accounts.";
export const ManageStoreAndLeadSettingsText = "Manage Store & Lead Settings";
export const ChangeManageStoreAndLeadSettingsText =
	"Change how homeowners see your store when searching our sites & how that store receives leads";
export const AdminSearchResultsHeader = "SEARCH RESULTS";
export const AdminSearchNoResultsFoundHeader = "We're sorry, we couldn't find any results!";
export const AdminSearchNoResultsFoundSubheader = "To see results in this list, please try:";
export const AdminSearchUserBullet = "Search by User's Name or Email Address";
export const AdminSearchAccountBullet = "Search by Account Number or Name";
export const AdminSearchBillToBullet = "Search by Bill To Id or Name";
export const AdminSearchCheckYourSpellingBullet = "Checking your search spelling";
export const SearchAccountsText = "Search Accounts";
export const AllAccountsText = "ALL ACCOUNTS";
export const AccountNameText = "Account Name";
export const AckEmailsQuantityText = "Ack. Emails";
export const BillToQuantityText = "Bill To Qty.";
export const BillToNameText = "Bill To Name";
export const BillToNumberText = "Bill To #";
export const BillToAckEmailText = "Ack Email";
export const BillToPricingFormatText = "Pricing Format";
export const AcknowledgementPriceFormatListText = "List";
export const AcknowledgementPriceFormatNetText = "Net";
export const AcknowledgementPriceFormatNetWithMultiplierText = "Net with Multiplier";
export const AcknowledgementPriceFormatVariousText = "Various";
export const BillTosPageHeaderText = "Bill To's for Account";
export const SearchBillTosText = "Search Bill Tos";
export const AdminStoreSearchUserBullet = "Search by Store Name or Address";

export const MultiplierText = "Multiplier";
export const StockOrdersText = "Stock Orders";
